var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModule12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.6V4.8C3 4.32261 3.18964 3.86477 3.52721 3.52721C3.86477 3.18964 4.32261 3 4.8 3H14.7M3 15.6C3 15.1226 3.18964 14.6649 3.52721 14.3273C3.86477 13.9897 4.32261 13.8001 4.8 13.8001H5.7M3 15.6C3 16.0774 3.18964 16.5353 3.52721 16.8729C3.86477 17.2105 4.32261 17.4001 4.8 17.4001H5.7M21 17.4001H11.1C10.6226 17.4001 10.1648 17.5897 9.82721 17.9273C9.48964 18.2649 9.3 18.7227 9.3 19.2001M9.3 19.2001C9.3 19.6775 9.48964 20.1353 9.82721 20.4729C10.1648 20.8105 10.6226 21.0001 11.1 21.0001H20.55C20.6693 21.0001 20.7838 20.9527 20.8682 20.8683C20.9526 20.7839 21 20.6694 21 20.5501V7.0501C21 6.93075 20.9526 6.81629 20.8682 6.7319C20.7838 6.64751 20.6693 6.6001 20.55 6.6001H11.1C10.6226 6.6001 10.1648 6.78974 9.82721 7.12731C9.48964 7.46487 9.3 7.92271 9.3 8.4001V19.2001Z",
    stroke: "#192048",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule12);
export default __webpack_public_path__ + "static/media/CustomModule12.1074dad3ad9477a4657449ace5b24362.svg";
export { ForwardRef as ReactComponent };